export default {
  formId: 'editarEmployeFormModel', //'checkoutForm',
  formField: {
    // DATOS BASICOS
    e_document_type: {
      name: 'e_document_type',
      label: 'Editar tipo de documento',
      requiredErrorMsg: 'Tipo de documento es requerido.',
    },
    e_file_img_upload: {
      name: 'e_file_img_upload',
      label: 'Editar subir archivo*',
      requiredErrorMsg: 'Subir archivo es requerido.',
    },
    e_document_number: {
      name: 'e_document_number',
      label: 'Editar numero de documento*',
      requiredErrorMsg: 'Numero de documento es requerido.',
      typeDataMsg: 'El campo es numerico.',
    },
    e_expedition_place: {
      name: 'e_expedition_place',
      label: 'Editar lugar de expedicion*',
      requiredErrorMsg: 'Lugar de expedicion es requerido.',
    },
    e_name: {
      name: 'e_name',
      label: 'Editar nombre*',
      requiredErrorMsg: 'El nombre  es requerido.',
    },
    e_last_name: {
      name: 'e_last_name',
      label: 'Editar apellidos*',
      requiredErrorMsg: 'Los apellidos son requeridos.',
    },
    e_date_of_birth: {
      name: 'e_date_of_birth',
      label: 'Editar fecha de Nacimiento',
      requiredErrorMsg: 'Fecha de Nacimiento es requerida.',
    },
    e_gender: {
      name: 'e_gender',
      label: 'Editar genero',
      requiredErrorMsg: 'Genero es requerido.',
    },
    e_civil_status: {
      name: 'e_civil_status',
      label: 'Editar estado civil',
      requiredErrorMsg: 'Estado civil es requerido.',
    },
    e_landline: {
      name: 'e_landline',
      label: 'Editar telefono fijo',
      requiredErrorMsg: 'Telefono fijo es requerido.',
    },
    e_cell_phone: {
      name: 'e_cell_phone',
      label: 'Editar celular',
      requiredErrorMsg: 'Celular es requerido.',
    },
    e_corporate_cell_phone: {
      name: 'e_corporate_cell_phone',
      label: 'Editar número corporativo',
      requiredErrorMsg: 'Número corporativo es requerido.',
    },
    e_whatsapp: {
      name: 'e_whatsapp',
      label: 'Editar este numero usa whatsapp?',
      requiredErrorMsg: 'El whatsapp es obligatorio.',
    },
    e_rh: {
      name: 'e_rh',
      label: 'Editar tipo de sangre',
      requiredErrorMsg: 'Tipo de sangre es requerido.',
    },
    e_dominance: {
      name: 'e_dominance',
      label: 'Editar dominacion',
      requiredErrorMsg: 'Dominacion es requerido.',
    },
    e_allergies: {
      name: 'e_allergies',
      label: 'Editar alergias',
      requiredErrorMsg: 'alergias es requerido.',
    },
    e_cedula: {
      name: 'e_cedula',
      label: 'Editar cedula',
      requiredErrorMsg: 'Cedula es requerido.',
    },
    e_address: {
      name: 'e_address',
      label: 'Editar direccion Empleado*',
      requiredErrorMsg: 'La direccion es requerida.',
    },
    e_email: {
      name: 'e_email',
      label: 'Editar email*',
      requiredErrorMsg: 'El email es requerido.',
    },
    e_housing_type: {
      name: 'e_housing_type',
      label: 'Editar tipo vivienda*',
      requiredErrorMsg: 'El tipo vivienda es requerida.',
    },
    e_neighborhood: {
      name: 'e_neighborhood',
      label: 'Editar barrio*',
      requiredErrorMsg: 'El barrio es requerida.',
    },
    e_stratum: {
      name: 'e_stratum',
      label: 'Editar estrato*',
      requiredErrorMsg: 'El estrato es requerida.',
    },
    e_cost_center: {
      name: 'e_cost_center',
      label: 'Editar centro de costos*',
      requiredErrorMsg: 'El centro de costos es requerida.',
    },
    e_compani: {
      name: 'e_compani',
      label: 'Editar compañia*',
      requiredErrorMsg: 'El compañia es requerida.',
    },
    e_work_headquarters: {
      name: 'e_work_headquarters',
      label: 'Editar sucursal*',
      requiredErrorMsg: 'La Sucursal es requerida.',
    },
    e_cargo: {
      name: 'e_cargo',
      label: 'Editar cargo*',
      requiredErrorMsg: 'El cargo es requerida.',
    },
    e_cv: {
      name: 'e_cv',
      label: 'Editar hoja de vida*',
      requiredErrorMsg: 'La hoja de vida es requerida.',
    },
    e_scholarship: {
      name: 'e_scholarship',
      label: 'Editar escolaridad*',
      requiredErrorMsg: 'La escolaridad es requerida.',
    },
    e_institution: {
      name: 'e_institution',
      label: 'Editar institucion*',
      requiredErrorMsg: 'La institucion es requerida.',
    },
    e_degree: {
      name: 'e_degree',
      label: 'Editar titulo*',
      requiredErrorMsg: 'La titulo es requerida.',
    },
    // DOCUMENTOS
    e_cedula_name_saved_name: {
      name: 'e_cedula_name_saved_name',
      label: 'Editar cedula',
      requiredErrorMsg: 'Cedula es requerido.',
    },
    e_cv_name_saved_name: {
      name: 'e_cv_name_saved_name',
      label: 'Editar hoja de vida',
      requiredErrorMsg: 'Hoja de vida es requerido.',
    },

    // LABORAL
    e_type_contract: {
      name: 'e_type_contract',
      label: 'Editar tipo de contrato',
      requiredErrorMsg: 'Tipo de contrato es requerido.',
    },
    e_salary_base: {
      name: 'e_salary_base',
      label: 'Editar salario base',
      requiredErrorMsg: 'Salario base es requerido.',
      typeDataMsg: 'El campo es numerico.',
    },
    e_transport_subsidy: {
      name: 'e_transport_subsidy',
      label: 'Editar subsidio transporte',
      requiredErrorMsg: 'Subsidio transporte es requerido.',
    },
    e_payment_method: {
      name: 'e_payment_method',
      label: 'Editar metodo de pago',
      requiredErrorMsg: 'Metodo de pago es requerido.',
    },
    e_frecuency_payment: {
      name: 'e_frecuency_payment',
      label: 'Editar frecuencia de pago',
      requiredErrorMsg: 'Frecuencia de pago es requerido.',
    },
    e_associated_bank: {
      name: 'e_associated_bank',
      label: 'Editar banco',
      requiredErrorMsg: 'Banco es requerido.',
    },
    e_account_number: {
      name: 'e_account_number',
      label: 'Editar numero de cuenta',
      requiredErrorMsg: 'Numero de cuenta es requerido.',
    },
    e_certificate_bank: {
      name: 'e_certificate_bank',
      label: 'Editar certificado bancario',
      requiredErrorMsg: 'Certificado bancario es requerido.',
    },
    e_vacation_acumulate: {
      name: 'e_vacation_acumulate',
      label: 'Editar vacaciones acumuladas',
      requiredErrorMsg: 'Vacaciones acumuladas es requerida.',
      typeDataMsg: 'El campo es numerico.',
    },
    e_bonification_aditional: {
      name: 'e_bonification_aditional',
      label: 'Editar bonificacion adicional',
      requiredErrorMsg: 'Bonificacion adicional es requerida.',
      typeDataMsg: 'El campo es numerico.',
    },
    e_date_start_contract: {
      name: 'e_date_start_contract',
      label: 'Editar fecha de contratacion',
      requiredErrorMsg: 'Fecha de contratacion es requerida.',
    },
    e_lunes: {
      name: 'e_lunes',
      label: 'lunes',
      requiredErrorMsg: 'lunes es requerido.',
    },
    e_martes: {
      name: 'e_martes',
      label: 'martes',
      requiredErrorMsg: 'martes es requerido.',
    },
    e_miercoles: {
      name: 'e_miercoles',
      label: 'miercoles',
      requiredErrorMsg: 'miercoles es requerido.',
    },
    e_jueves: {
      name: 'e_jueves',
      label: 'jueves',
      requiredErrorMsg: 'jueves es requerido.',
    },
    e_viernes: {
      name: 'e_viernes',
      label: 'viernes',
      requiredErrorMsg: 'viernes es requerido.',
    },
    e_sabado: {
      name: 'e_sabado',
      label: 'sabado',
      requiredErrorMsg: 'sabado es requerido.',
    },
    e_domingo: {
      name: 'e_domingo',
      label: 'domingo',
      requiredErrorMsg: 'domingo es requerido.',
    },
    e_festivo: {
      name: 'e_festivo',
      label: 'festivo',
      requiredErrorMsg: 'festivo es requerido.',
    },
    e_dayrest: {
      name: 'e_dayrest',
      label: 'Editar dayrest',
      requiredErrorMsg: 'Debes selecionar al menos un dia de descanso*',
    },
    // LABORAL
    e_certificate_banck_name_saved_name: {
      name: 'e_certificate_banck_name_saved_name',
      label: 'Editar certificado bancario',
      requiredErrorMsg: 'Certificado bancario es requerido.',
    },
    // FAMILIA
    e_numOfBeneficiary: {
      name: 'e_numOfBeneficiary',
      label: 'Editar numero de beneficiarios',
      requiredErrorMsg: 'Numero de beneficiarios es requerido.',
    },
    // e_family: {
    //   name: 'e_family',
    //   label: 'Editar familia',
    //   requiredErrorMsg: 'Familia es requerido.'
    // },
    // SEGURIDAD SOCIAL
    e_eps: {
      name: 'e_eps',
      label: 'Editar eps',
      requiredErrorMsg: 'Eps es requerido.',
    },
    // CAJA DE COMPENSACION
    e_familyCompensation: {
      name: 'e_familyCompensation',
      label: 'Editar caja de compensacion',
      requiredErrorMsg: 'Caja de compensacion es requerido.',
    },
    e_fileCajaCompensacion: {
      name: 'e_fileCajaCompensacion',
      label: 'Editar caja de compensacion',
      requiredErrorMsg: 'Caja de compensacion es requerido.',
    },
    e_caja_compensacion_name_saved: {
      name: 'e_caja_compensacion_name_saved',
      label: 'Editar caja compensacion',
      requiredErrorMsg: 'Caja compensacion es requerido.',
    },
    // CESANTIAS
    e_cesantias: {
      name: 'e_cesantias',
      label: 'Editar cesantias',
      requiredErrorMsg: 'Cesantias es requerido.',
    },
    e_fileCesantias: {
      name: 'e_fileCesantias',
      label: 'Editar cesantias',
      requiredErrorMsg: 'Cesantias es requerido.',
    },
    e_cesantias_name_saved: {
      name: 'e_cesantias_name_saved',
      label: 'Editar cesantias',
      requiredErrorMsg: 'Cesantias es requerido.',
    },
    // PENSION
    e_pension: {
      name: 'e_pension',
      label: 'Editar pension',
      requiredErrorMsg: 'Pension es requerido.',
    },
    // ARL
    e_fileArl: {
      name: 'e_fileArl',
      label: 'Editar arl',
      requiredErrorMsg: 'Arl es requerido.',
    },
    e_arl_name_saved: {
      name: 'e_arl_name_saved',
      label: 'Editar arl',
      requiredErrorMsg: 'Arl es requerido.',
    },
    // DOTACION
    // e_items_uno: {
    //   name: 'e_items',
    //   label: 'Editar items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // e_talla_uno: {
    //   name: 'e_talla',
    //   label: 'Editar talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // e_cantidad_uno: {
    //   name: 'e_cantidad',
    //   label: 'Editar cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // e_color_uno: {
    //   name: 'e_color',
    //   label: 'Editar color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // e_item_descripcion_uno: {
    //   name: 'e_item_descripcion',
    //   label: 'Editar descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // e_items2: {
    //   name: 'e_items',
    //   label: 'Editar items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // e_talla2: {
    //   name: 'e_talla',
    //   label: 'Editar talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // e_cantidad2: {
    //   name: 'e_cantidad',
    //   label: 'Editar cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // e_color2: {
    //   name: 'e_color',
    //   label: 'Editar color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // e_item_descripcion2: {
    //   name: 'e_item_descripcion',
    //   label: 'Editar descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // e_items3: {
    //   name: 'e_items',
    //   label: 'Editar items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // e_talla3: {
    //   name: 'e_talla',
    //   label: 'Editar talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // e_cantidad3: {
    //   name: 'e_cantidad',
    //   label: 'Editar cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // e_color3: {
    //   name: 'e_color',
    //   label: 'Editar color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // e_item_descripcion3: {
    //   name: 'e_item_descripcion',
    //   label: 'Editar descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // e_items4: {
    //   name: 'e_items',
    //   label: 'Editar items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // e_talla4: {
    //   name: 'e_talla',
    //   label: 'Editar talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // e_cantidad4: {
    //   name: 'e_cantidad',
    //   label: 'Editar cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // e_color4: {
    //   name: 'e_color',
    //   label: 'Editar color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // e_item_descripcion4: {
    //   name: 'e_item_descripcion',
    //   label: 'Editar descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // e_items5: {
    //   name: 'e_items',
    //   label: 'Editar items',
    //   requiredErrorMsg: 'Items es requerido.'
    // },
    // e_talla5: {
    //   name: 'e_talla',
    //   label: 'Editar talla',
    //   requiredErrorMsg: 'Talla es requerido.'
    // },
    // e_cantidad5: {
    //   name: 'e_cantidad',
    //   label: 'Editar cantidad',
    //   requiredErrorMsg: 'Cantidad es requerido.'
    // },
    // e_color5: {
    //   name: 'e_color',
    //   label: 'Editar color',
    //   requiredErrorMsg: 'Color es requerido.'
    // },
    // e_item_descripcion5: {
    //   name: 'e_item_descripcion',
    //   label: 'Editar descipcion',
    //   requiredErrorMsg: 'Descipcion es requerido.'
    // },
    // PRUEBAS DE INGRESO / VISITA DOMICILIARIA
    e_vista_domiciliaria: {
      name: 'e_vista_domiciliaria',
      label: 'Editar visita domiciliaria',
      requiredErrorMsg: 'Visita domiciliaria es requerido.',
    },
    e_fileVisitaDomiciliaria: {
      name: 'e_fileVisitaDomiciliaria',
      label: 'Editar visita domiciliaria',
      requiredErrorMsg: 'Visita domiciliaria es requerido.',
    },
    e_visita_domiciliaria_name_saved: {
      name: 'e_visita_domiciliaria_name_saved',
      label: 'Editar visita domiciliaria',
      requiredErrorMsg: 'Visita domiciliaria es requerido.',
    },
    // PRUEBA PSICOTECNICA
    e_prueba_psicotecnica: {
      name: 'e_prueba_psicotecnica',
      label: 'Editar pruebas psicotecnicas',
      requiredErrorMsg: 'Pruebas psicotecnicas es requerido.',
    },
    e_filePsicotecnica: {
      name: 'e_filePsicotecnica',
      label: 'Editar pruebas psicotecnicas',
      requiredErrorMsg: 'Pruebas psicotecnicas es requerido.',
    },
    e_psicotecnica_name_saved: {
      name: 'e_psicotecnica_name_saved',
      label: 'Editar pruebas psicotecnicas',
      requiredErrorMsg: 'Pruebas psicotecnicas es requerido.',
    },
    // MANIPULACION ALIMENTOS
    e_manipulacion_alimentos: {
      name: 'e_manipulacion_alimentos',
      label: 'Editar manipulacion alimentos',
      requiredErrorMsg: 'Manipulacion alimentos es requerido.',
    },
    e_fileManipulacionAlimentos: {
      name: 'e_fileManipulacionAlimentos',
      label: 'Editar manipulacion alimentos',
      requiredErrorMsg: 'Manipulacion alimentos es requerido.',
    },
    e_manipulacion_alimentos_name_saved: {
      name: 'e_manipulacion_alimentos_name_saved',
      label: 'Editar manipulacion alimentos',
      requiredErrorMsg: 'Manipulacion alimentos es requerido.',
    },
    // TRABAJO EN ALTURAS
    e_trabajo_alturas: {
      name: 'e_trabajo_alturas',
      label: 'Editar trabajo en alturas',
      requiredErrorMsg: 'Trabajo en alturas es requerido.',
    },
    e_fileTrabajoAlturas: {
      name: 'e_fileTrabajoAlturas',
      label: 'Editar trabajo en alturas',
      requiredErrorMsg: 'Trabajo en alturas es requerido.',
    },
    e_trabajo_altura_name_saved: {
      name: 'e_trabajo_altura_name_saved',
      label: 'Editar trabajo en alturas',
      requiredErrorMsg: 'Trabajo en alturas es requerido.',
    },
    // EXAMEN MEDICO
    e_examen_medico: {
      name: 'e_examen_medico',
      label: 'Editar examen medico',
      requiredErrorMsg: 'Examen medico es requerido.',
    },
    e_fileExamenMedico: {
      name: 'e_fileExamenMedico',
      label: 'Editar examen medico',
      requiredErrorMsg: 'Examen medico es requerido.',
    },
    e_examen_medico_name_saved: {
      name: 'e_examen_medico_name_saved',
      label: 'Editar examen medico',
      requiredErrorMsg: 'Examen medico es requerido.',
    },
    // CONTRATO
    e_contrato: {
      name: 'e_contrato',
      label: 'Editar contrato',
      requiredErrorMsg: 'contrato es requerido.',
    },
    // CERTIFICADO ESTUDIOS
    e_certificado_estudios: {
      name: 'e_certificado_estudios',
      label: 'Editar certificado estudios',
      requiredErrorMsg: 'Certificado estudios es requerido.',
    },
    e_fileCertificadoEstudios: {
      name: 'e_fileCertificadoEstudios',
      label: 'Editar certificado estudios',
      requiredErrorMsg: 'Certificado estudios es requerido.',
    },
    e_certificado_estudios_name_saved: {
      name: 'e_certificado_estudios_name_saved',
      label: 'Editar certificado estudios',
      requiredErrorMsg: 'Certificado estudios es requerido.',
    },
    // CERTIFICADO LABORAL
    e_certificado_laboral: {
      name: 'e_certificado_laboral',
      label: 'Editar certificado laboral',
      requiredErrorMsg: 'Certificado laboral es requerido.',
    },
    e_fileCertificadoLaboral: {
      name: 'e_fileCertificadoLaboral',
      label: 'Editar certificado laboral',
      requiredErrorMsg: 'Certificado laboral es requerido.',
    },
    e_certificado_laboral_name_saved: {
      name: 'e_certificado_laboral_name_saved',
      label: 'Editar certificado laboral',
      requiredErrorMsg: 'Certificado laboral es requerido.',
    },
    // VERIFICACION ADRES
    e_verificacion_adres: {
      name: 'e_verificacion_adres',
      label: 'Editar verificacion adres',
      requiredErrorMsg: 'Verificacion adres es requerido.',
    },
    e_fileVerificacionAdres: {
      name: 'e_fileVerificacionAdres',
      label: 'Editar verificacion adres',
      requiredErrorMsg: 'Verificacion adres es requerido.',
    },
    e_verificacion_adres_name_saved: {
      name: 'e_verificacion_adres_name_saved',
      label: 'Editar verificacion adres',
      requiredErrorMsg: 'Verificacion adres es requerido.',
    },
    // ANTECEDENTES
    e_antecedentes: {
      name: 'e_antecedentes',
      label: 'Editar antecedentes',
      requiredErrorMsg: 'Antecedentes es requerido.',
    },
    e_fileAntecedentes: {
      name: 'e_fileAntecedentes',
      label: 'Editar antecedentes',
      requiredErrorMsg: 'Antecedentes es requerido.',
    },
    e_antecedentes_name_saved: {
      name: 'e_antecedentes_name_saved',
      label: 'Editar antecedentes',
      requiredErrorMsg: 'Antecedentes es requerido.',
    },
    // ENTREVISTA
    e_entrevista: {
      name: 'e_entrevista',
      label: 'Editar entrevista',
      requiredErrorMsg: 'Entrevista es requerido.',
    },
    e_fileEntrevista: {
      name: 'e_fileEntrevista',
      label: 'Editar entrevista',
      requiredErrorMsg: 'Entrevista es requerido.',
    },
    e_entrevista_name_saved: {
      name: 'e_entrevista_name_saved',
      label: 'Editar entrevista',
      requiredErrorMsg: 'Entrevista es requerido.',
    },
    // ENTREVISTA SOCIODEMOGRAFICA
    e_sociodemografica: {
      name: 'e_sociodemografica',
      label: 'Editar entrevista sociodemografica',
      requiredErrorMsg: 'Entrevista sociodemografica es requerido.',
    },
    e_fileSociodemografica: {
      name: 'e_fileSociodemografica',
      label: 'Editar entrevista sociodemografica',
      requiredErrorMsg: 'Entrevista sociodemografica es requerido.',
    },
    e_sociodemografica_name_saved: {
      name: 'e_sociodemografica_name_saved',
      label: 'Editar entrevista sociodemografica',
      requiredErrorMsg: 'Entrevista sociodemografica es requerido.',
    },
    // ENCUESTA DME
    e_encuesta_dme: {
      name: 'e_encuesta_dme',
      label: 'Editar encuesta dme',
      requiredErrorMsg: 'Encuesta dme es requerido.',
    },
    e_fileEncuestaDme: {
      name: 'e_fileEncuestaDme',
      label: 'Editar encuesta dme',
      requiredErrorMsg: 'Encuesta dme es requerido.',
    },
    e_encuesta_dme_name_saved: {
      name: 'e_encuesta_dme_name_saved',
      label: 'Editar encuesta dme',
      requiredErrorMsg: 'Encuesta dme es requerido.',
    },
    // COMPROMISO SST
    e_compromiso_sst: {
      name: 'e_compromiso_sst',
      label: 'Editar compromiso sst',
      requiredErrorMsg: 'Compromiso sst es requerido.',
    },
    e_fileCompromisoSst: {
      name: 'e_fileCompromisoSst',
      label: 'Editar compromiso sst',
      requiredErrorMsg: 'Compromiso sst es requerido.',
    },
    e_compromiso_sst_name_saved: {
      name: 'e_compromiso_sst_name_saved',
      label: 'Editar compromiso sst',
      requiredErrorMsg: 'Compromiso sst es requerido.',
    },
  },
};
